import styled from "styled-components";

export const TableWrapper = styled.div`
  padding: 20px;
  > div {
    border-radius: 10px;
    box-shadow: 0 2px 10px 0 rgb(0 0 0 / 16%);
    padding: 15px 28px;
    @media (max-width: 767px) {
      padding: 15px;
      overflow: hidden;
    }
  }
  @media (max-width: 1250px) {
    padding: 15px;
    .community-details-header h4{
      font-size: 16px;
    }
  }
`;

export const MainContainer = styled.div`
  max-width: 1472px;
  margin: 0 auto;
  padding: 0 10px;
`;

export const TabPanelWrapper = styled.div`
  padding: 12px 75px;
  text-align: center;
  @media (max-width: 767px) {
    padding: 5px;
  }
  .tab-buttons {
    display: inline-block;
    border-bottom: 1px solid #D9D9D9;
    padding: 0 0 15px;

    @media (max-width: 767px) {
      overflow-x: auto;
      display:inline;
      padding: 0 0 45px;
    }
  }

  button {
    flex: none;
    order: 1;
    background: #B4DAEF;
    border: 1px solid #D9D9D9;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.15);
    border-radius: 5px;
    font-weight: normal;
    font-size: 18px;
    line-height: 24px;
    padding: 30px;
    color: #ffffff;
    min-width: 250px;
    background: #B4DAEF;
    margin-right: 30px;
    :last-child{
      margin-right:0px;
    }
    &.active{
      background: #064269;
      border: 1px solid #064269
    }
    @media (max-width: 767px) {
      max-width: 90px;
      padding: 10px;
      font-size: 15px;
      white-space: normal;
      word-break: break-word;
      min-width: 60px;
      margin-right: 15px;
    }
    @media (max-width: 420px) {
      max-width: 75px;
      font-size: 13px;
    }
  }

  .tab-content {
    margin-top: 25px;
    padding: 0px;
    // box-shadow: 4px 4px 4px rgba(0, 0, 0, 0.15);
  }
`;

export const SpecItem = styled.div`
  border: 1px solid #D9D9D9;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
  position: relative;
  background: #FFFFFF;
  padding:40px 0;
  margin-bottom: 18px;
  .item-top{
    font-size: 16px;
    font-weight: bold;
    color: #000000;
    width: 100%;
    align-items: center;
    text-align: center;
    padding-bottom: 14px;
  }
  .item-bottom{
    box-sizing: border-box;
    position: absolute;
    height: 27px;
    width: 100%;
    background: #DEEBFF;
    border-radius: 0px 0px 4px 4px;
    text-align: left;
    bottom:0;
    div {
      margin: 0 10px;
      p{
        font-size: 12px;
        font-weight: bold;
        color: #000000;
        line-height: 24px;
        margin: 0 5px 0 0;
        display: inline;
      }
      svg{
        cursor:pointer
      }
      @media (max-width: 420px){
        margin: 0 4px;
        p{
          font-size: 10px;
        }
    }
    }
  }
`;